import * as React from "react"
import type { IconProps } from "../types"

const Trash = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6 6V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V6M6 6H18M6 6H4M18 6H20M9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6M14 11V16M10 11V16"
        />
      </svg>
    )
  }
)
Trash.displayName = "Trash"

export default Trash